import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f67f838a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container-fluild outside-container",
  id: "coreContent"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "bg"
  }, null, -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "container long-container"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "row long-row"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-12 core"
  }, [/*#__PURE__*/_createElementVNode("h2", null, "核心价值观"), /*#__PURE__*/_createElementVNode("h3", null, "ZUOFEI CORE VALUE"), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h5", null, "自省者进，担当者强；以客为本，以质求胜。"), /*#__PURE__*/_createElementVNode("p", null, "昨非的愿景与使命是成为全球领先的生物实验室设备中国品牌"), /*#__PURE__*/_createElementVNode("p", null, "致力于帮助我们的客户以最低的投入成本、最高效的实验过程和最精准的实验成果推动生命科学与技术的创新与发展"), /*#__PURE__*/_createElementVNode("p", null, "进而惠及全球每一个平凡但独一无二的生命个体。"), /*#__PURE__*/_createElementVNode("p", null, "虽时光荏苒，但我们终生向客户提供高质量的产品、服务和解决方案的承诺永不改变！")])])])], -1);
});

var _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}